import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react/components/Modal';
import { actionCreators } from 'react/api/actions/routeSurveyModal';
import * as selectors from 'react/api/selectors/routeSurveyModal';
import Loading from 'react/components/Loading';
import Sidebar from './Sidebar';
import SurveyList from './SurveyList';
import ToasterContainer from './ToasterContainer';

class RouteSurveyModal extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const { fetchSurveysAction, routeId, stopId, isOpen } = this.props;
    if (isOpen && prevProps.isOpen !== isOpen) {
      fetchSurveysAction({ routeId, stopId });
    }
  }

  render() {
    const {
      routeId, 
      stopId, 
      isOpen, 
      closeAction, 
      isLoading, 
      title, 
      subtitle,
      ...others
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        closeModalFn={() => {
          closeAction({ routeId: String(routeId), stopId: String(stopId)})
        }}
        title={title}
        subtitle={subtitle}
        style={{ width: '100%' }}
        toaster={<ToasterContainer routeId={String(routeId)} stopId={String(stopId)} />}
        {...others}
      >
        {
          isLoading ? <Loading theme="gray" /> : (
            <>
              <Sidebar routeId={String(routeId)} stopId={String(stopId)} />
              <SurveyList routeId={String(routeId)} stopId={String(stopId)} />
            </>
          )
        }
      </Modal>
    );
  }
}

RouteSurveyModal.propTypes = {
  // state
  routeId: PropTypes.number.isRequired,
  stopId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  // actions
  closeAction: PropTypes.func.isRequired,
  fetchSurveysAction: PropTypes.func.isRequired,
  selectSidebarItemAction: PropTypes.func.isRequired
};

const mapStateToProps = (state, { routeId, stopId }) => ({
  isOpen: selectors.getIsOpen(state, String(routeId), String(stopId)),
  isLoading: selectors.getIsLoading(state, String(routeId), String(stopId)),
});

const mapDispatchToProps = {
  closeAction: actionCreators.close,
  fetchSurveysAction: actionCreators.fetchSurveys,
  selectSidebarItemAction: actionCreators.selectSidebarItem
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteSurveyModal);
